import { mapState, mapActions } from 'vuex';
import messages from './exchange-lang.json';
import exchangeForm from './exchange-form/exchange-form.vue';
import exchangeResults from './exchange-results/exchange-results.vue';
export default {
	data() {
		return {};
	},
	i18n: { messages },
	components: {
		'exchange-form': exchangeForm,
		'exchange-results': exchangeResults
	},
	computed: {
		...mapState('exchange', ['technicalError', 'loading', 'currencies', 'results'])
	},
	methods: {
		...mapActions('exchange', ['getCurrencies', 'calculate', 'resetResults'])
	},
	mounted: function () {
		this.getCurrencies();
	}
};
